import _ from 'lodash';
import queryString from 'query-string';
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from 'react-redux';
import { createNotification } from 'react-redux-notify';
import { useNavigate, useLocation } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';

import {
  deleteConversationStart,
  fetchUserChatroomsStart,
  setActiveConversation
} from '../../store/actions/ChatAction';
import ChatWindow from './ChatWindow';
import ChatWindowEmpty from './ChatWindowEmpty';
import { SidebarFilter } from './MessageSidebar';
import ChatWindowBulkSend from './ChatWindowBulkSend';
import { getUserId } from '../../helpers/storage/user';
import ReportUserModal from '../Modals/ReportUserModal';
import { formatLastSeen } from '../../helpers/date/date';
import ConfirmYesNoModal from '../Modals/ConfirmYesNoModal';
import { ChatWindowHeaderMobile } from './ChatWindowHeader';
import NewConversationModal from '../Modals/NewConversation';
import timeService from '../../helpers/utils/formatTimeToMin';
import MessageValidator from '../../helpers/validator/message';
import UserConstantsHelper from '../../helpers/constants/user';
import { SpinnerLoader } from '../../components/Loader/ChatLoader';
import { SidebarListTypes } from '../../helpers/constants/message';
import { SocketContext } from '../../helpers/contexts/communication';
import { ChatroomStatusEnum } from '../../helpers/constants/message';
import LinearProgressModal from '../../components/Modals/LinearProgress';
import { getErrorNotificationMessage } from '../helper/NotificationMessage';
import { ChatWindowBulkSenderHeaderMobile } from './ChatWindowBulkSendHeader';
import { isAuthenticated } from '../../helpers/authentication/authentication';
import { showUnverifiedPerformerModal, showPerformerMissingProfilePictureModal } from '../../store/actions/ModalAction';

import './style_new.scss';
import '../LandingPageIndex/Login.scss'

export const ChatroomsFilter = {
  All: 'All',
  Active: 'Active',
  Hidden: 'Hidden',
  Blocked: 'Blocked',
};

const MessageIndex = ({ title }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [progress, setProgress] = useState(0);
  const [showReport, setShowReport] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const profile = useSelector((state) => state.users.profile);
  const chatrooms = useSelector((state) => state.chat.chatrooms);
  const chatFilters = useSelector((state) => state.chat.chatFilters);
  const [showNewConverstaion, setShowNewConverstaion] = useState(false);
  const [showDeleteConverstaionConfirmation, setShowDeleteConverstaionConfirmation] = useState(false);
  const { chatroom: activeChatroom, member, loading } = useSelector((state) => state.chat.activeConversation);
  const [isSidebarClass, setIsSidebarClass] = useState({
    first: 'mobileTabletView',
    second: 'mobileTabletNone',
  });

  const {
    sendMessage,
    isLoading,
    joinChatroom,
    sendBulkMessage,
    changeChatroomStatus,
    fetchChatroomMessages,
    changeChatroomVisibility,
    changeChatroomNotification,
    connected,
    connect
  } = useContext(SocketContext);

  useEffect(() => {
    if (isAuthenticated() && connect && !connected) {
      connect();
    }
  }, []);

  useEffect(() => {
    let query = { user_id: getUserId(), chatroomsFilter: chatFilters.chatroomsFilter }
    if (chatFilters?.chatroomSearhcQuery) {
      query = { ...query, query: chatFilters.chatroomSearhcQuery }
    }
    dispatch(fetchUserChatroomsStart(query));
    return () => {
      dispatch(setActiveConversation({ chatroom: {}, member: {} }));
    };
  }, [chatFilters.chatroomsFilter, chatFilters.chatroomSearhcQuery]);

  useEffect(() => {
    const { room } = queryString.parse(location.search);
    if (room && (activeChatroom?.id?.toString() !== room?.toString())) {
      joinChatroom(room, getUserId());
    }
  }, [location.search]);

  useEffect(() => {
    if (
      isSidebarClass &&
      isSidebarClass.first === 'mobileTabletNone' &&
      isSidebarClass.second === 'mobileTabletView' &&
      chatFilters.sidebarListType === SidebarListTypes.Chatrooms
    ) {
      setIsSidebarClass({
        first: 'mobileTabletView',
        second: 'mobileTabletNone',
      });
    }
  }, [chatFilters.sidebarListType]);

  useEffect(() => {
    const { room } = queryString.parse(location.search);
    if (activeChatroom && room && activeChatroom?.id?.toString() === room?.toString()) {
      setIsSidebarClass({
        first: 'mobileTabletNone',
        second: 'mobileTabletView',
      });
    }
  }, [activeChatroom])

  function onSendMessage(message, assets = [], price = 0) {
    if (UserConstantsHelper.isPerformerNotApproved(profile.data)) {
      dispatch(showUnverifiedPerformerModal());
      return false;
    }

    if (UserConstantsHelper.isPerformerRequiredToUploadProfilePicture(profile.data)) {
      dispatch(showPerformerMissingProfilePictureModal())
      return false;
    }

    let result = MessageValidator.validMessageContent({
      price,
      assets,
      message,
    });
    if (!result.status) {
      const notificationMessage = getErrorNotificationMessage(result.message);
      dispatch(createNotification(notificationMessage));
      return false;
    }

    sendMessage(getUserId(), activeChatroom.id, message, assets, price);
    return true;
  }

  const handleSidebarClass = () => {
    if (
      isSidebarClass &&
      isSidebarClass.first === 'mobileTabletView' &&
      isSidebarClass.second === 'mobileTabletNone'
    ) {
      setIsSidebarClass({
        first: 'mobileTabletNone',
        second: 'mobileTabletView',
      });
    } else {
      setIsSidebarClass({
        first: 'mobileTabletView',
        second: 'mobileTabletNone',
      });
    }
  };

  const handleFetchMessages = (chatroom_id, page = 0) => {
    fetchChatroomMessages(chatroom_id, page);
  };

  const onNewConversation = () => {
    setShowNewConverstaion(true);
  };

  const closeReportModal = () => {
    setShowReport(false);
  };

  const closeNewConversation = () => {
    setShowNewConverstaion(false);
  };

  const deleteConverstaion = (chatroom_id) => {
    dispatch(deleteConversationStart(chatroom_id));
  };

  const muteChatroomNotification = (chatroom_id) => {
    changeChatroomNotification(chatroom_id, false);
  };

  const unmuteChatroomNotification = (chatroom_id) => {
    changeChatroomNotification(chatroom_id, true);
  };

  const setChatroomVisible = (chatroom_id) => {
    changeChatroomVisibility(chatroom_id, true);
  };

  const setChatroomInvisible = (chatroom_id) => {
    changeChatroomVisibility(chatroom_id, false);
  };

  const blockChatroom = (chatroom_id) => {
    changeChatroomStatus(chatroom_id, ChatroomStatusEnum.Blocked);
  };

  const unblockChatroom = (chatroom_id) => {
    changeChatroomStatus(chatroom_id, ChatroomStatusEnum.Active);
  };

  const getUserStatus = (chatroom) => {
    if (timeService.updateOnlineStatus(chatroom?.member?.last_seen, chatroom?.member?.online_status)) {
      return 'Online';
    } else {
      if (member?.deleted_at) {
        return 'Inactive User'
      }
      if (chatroom?.status === ChatroomStatusEnum.Blocked) {
        return 'Blocked';
      }
      if (!member || !member?.last_seen) {
        return 'Seen long time ago';
      }
      return `Last seen ${formatLastSeen(member?.last_seen)}`;
    }
  };

  const onNewConverstaionSuccess = (chatroom) => {
    setShowNewConverstaion(false);
    dispatch(fetchUserChatroomsStart({
      user_id: getUserId(),
      chatroomsFilter: chatFilters.chatroomsFilter
    }));
    navigate(`/inbox?room=${chatroom?.id}`);
  };

  const handleDeleteConversation = () => {
    if (activeChatroom) {
      deleteConverstaion(activeChatroom.id)
    }
  };

  const toggleDeleteConverstaionConfirmation = () => {
    setShowDeleteConverstaionConfirmation(!showDeleteConverstaionConfirmation)
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={`chatSeting mobichat ${isSidebarClass.second}`}>
        {chatFilters.sidebarListType === SidebarListTypes.Chatrooms && (
          <ChatWindowHeaderMobile
            member={member}
            blockChatroom={blockChatroom}
            getUserStatus={getUserStatus}
            setShowReport={setShowReport}
            unblockChatroom={unblockChatroom}
            handleSidebarClass={handleSidebarClass}
            setChatroomVisible={setChatroomVisible}
            setChatroomInvisible={setChatroomInvisible}
            muteChatroomNotification={muteChatroomNotification}
            unmuteChatroomNotification={unmuteChatroomNotification}
            setShowDeleteConverstaionConfirmation={setShowDeleteConverstaionConfirmation}
          />
        )}
        {chatFilters.sidebarListType === SidebarListTypes.Users && (
          <ChatWindowBulkSenderHeaderMobile handleSidebarClass={handleSidebarClass} />
        )}
      </div>
      <div className='chatwindowmain container'>
        <div className='row chatviewmain'>
          <div className={`col-xl-4 h-inherit ${isSidebarClass.first}`}>
            <div className='siders-chat mt-2'>
              <SidebarFilter
                onNewConversation={onNewConversation}
                handleSidebarClass={handleSidebarClass}
              />
            </div>
          </div>
          <div className={`col-xl-8 h-inherit position-relative ${isSidebarClass.second}`}>
            {chatFilters.sidebarListType === SidebarListTypes.Chatrooms && (
              <>
                {loading || !connected
                  ? (<SpinnerLoader />)
                  : (
                    <>
                      {activeChatroom?.id && (
                        <ChatWindow
                          member={member}
                          setProgress={setProgress}
                          setShowReport={setShowReport}
                          getUserStatus={getUserStatus}
                          isLoading={isLoading}
                          onSendMessage={onSendMessage}
                          blockChatroom={blockChatroom}
                          isSidebarClass={isSidebarClass}
                          setShowProgress={setShowProgress}
                          unblockChatroom={unblockChatroom}
                          setChatroomVisible={setChatroomVisible}
                          handleFetchMessages={handleFetchMessages}
                          setChatroomInvisible={setChatroomInvisible}
                          muteChatroomNotification={muteChatroomNotification}
                          unmuteChatroomNotification={unmuteChatroomNotification}
                          setShowDeleteConverstaionConfirmation={setShowDeleteConverstaionConfirmation}
                        />
                      )}
                      {activeChatroom?.member_id && <ChatWindowEmpty onNewConversation={onNewConversation} />}
                    </>
                  )
                }
              </>
            )}
            {chatFilters.sidebarListType === SidebarListTypes.Users && (
              <ChatWindowBulkSend
                setProgress={setProgress}
                isSidebarClass={isSidebarClass}
                setShowProgress={setShowProgress}
                onSendBulkMessage={sendBulkMessage}
              />
            )}
          </div>
        </div>
      </div>
      {showProgress && (
        <LinearProgressModal message='Uploading' progress={progress} isOpen={showProgress} />
      )}
      <ReportUserModal data={{ user_id: member?.id }} show={showReport} close={closeReportModal} />
      <NewConversationModal
        show={showNewConverstaion}
        close={closeNewConversation}
        onSuccess={onNewConverstaionSuccess}
      />
      <ConfirmYesNoModal
        isOpen={showDeleteConverstaionConfirmation}
        toggleModal={toggleDeleteConverstaionConfirmation}
        message="Are you sure you want to delete this conversation?"
        continueAction={handleDeleteConversation}
      />
    </>
  );
};

export default MessageIndex;
